"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertor = exports.taskFromOperationNode = void 0;
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const uiNodes_1 = require("../../uiNodes");
const types_1 = require("./types");
const taskToOperationNode = (task) => {
    const { srcArtifactSlug: _unused1, otherArtifactSlugs: _unused2, ...nodeConfiguration } = task;
    const tapeBuilderNodeId = (0, uuid_1.v4)();
    const operationNode = {
        metadata: {
            tapeBuilderNodeId,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: nodeConfiguration,
    };
    return operationNode;
};
const taskFromOperationNode = ({ srcNodes, operationNode, }) => {
    const { configuration } = operationNode;
    (0, common_1.finleyAssert)(srcNodes.length >= 1, `stack node has [${srcNodes.length}] src nodes`);
    const artifactSlugs = srcNodes.map((srcNode) => {
        const uiNode = (0, uiNodes_1.getUINodeByType)(srcNode.metadata.tapeBuilderNodeType);
        (0, common_1.finleyAssert)(!uiNode.isOperation, 'src node is an operation node');
        return uiNode.getArtifactSlug(srcNode);
    });
    const srcArtifactSlug = artifactSlugs.shift();
    return {
        ...configuration,
        srcArtifactSlug: (0, tape_builder_base_1.asArtifactSlugRef)(srcArtifactSlug),
        otherArtifactSlugs: artifactSlugs.map((slug) => (0, tape_builder_base_1.asArtifactSlugRef)(slug)),
    };
};
exports.taskFromOperationNode = taskFromOperationNode;
exports.convertor = {
    operation: 'stack',
    nodeType: types_1.nodeType,
    taskToOperationNode,
    taskFromOperationNode: exports.taskFromOperationNode,
    getInputSlugs: (task) => [task.srcArtifactSlug, ...task.otherArtifactSlugs],
    toTransformation: (task, resolveDef) => {
        const { srcArtifactSlug, otherArtifactSlugs, ensureUniqueFields } = task;
        const inputSlugs = [srcArtifactSlug, ...otherArtifactSlugs];
        const inputTapeDefinitionResults = inputSlugs.map((slug) => resolveDef(slug));
        const errors = [];
        const inputTapeDefinitions = inputTapeDefinitionResults.map((tape) => {
            if (!tape.isValid) {
                errors.push(...tape.errors);
                return null;
            }
            if (!tape.data) {
                errors.push('Stack operation requires sanitized tapes as inputs. Are you using the correct tapes?');
                return null;
            }
            return tape.data;
        });
        if (errors.length) {
            return {
                isValid: false,
                errors,
            };
        }
        const validTapeDefinitions = inputTapeDefinitions.filter(common_1.typeguards.isNotNullOrUndefined);
        return {
            isValid: true,
            data: {
                operation: 'stack',
                srcDataTape: validTapeDefinitions[0],
                otherDataTapes: validTapeDefinitions.slice(1),
                ensureUniqueFields,
            },
        };
    },
};
//# sourceMappingURL=converter.js.map